import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { AppConstant } from 'src/app/constants/app.constant';
import { MonthlyPaymentMode } from 'src/app/models/virtual-store/monthly-payment.model';
import { Service } from 'src/app/models/virtual-store/service.model';

@Component({
  selector: 'app-popup-service',
  templateUrl: './popup-service.component.html',
  styleUrls: ['./popup-service.component.scss']
})
export class PopupServiceComponent implements OnInit {

  service: any = null;
  itemService: Service = null;
  selectedMonthlyPaymentMode = new MonthlyPaymentMode();
  codeFilterFnb:string=AppConstant.FNB;  
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
  public dialogRef: MatDialogRef<any>) { }

  ngOnInit() {
    this.service = this.data.service;
    this.itemService = this.data.itemService;
    this.selectedMonthlyPaymentMode = this.data.service.monthlyPaymentModeList[0];
  }

  add(){
    this.itemService.monthlyPaymentCount = this.selectedMonthlyPaymentMode.monthCount;
    this.itemService.aggregate = true;
    this.dialogRef.close(this.itemService);
  }

  cancel(){
    this.itemService.aggregate = false;
    this.dialogRef.close(this.itemService);
  }

}
